import React from "react";
import BlogEighteen from "../component/BlogEighteen";

function BlogEighteenContainer() {
  return <BlogEighteen />;
}
export default BlogEighteenContainer;
